import React, {Suspense, useEffect, useState} from "react";
import {Html, useGLTF, useProgress} from "@react-three/drei";
import {Interactive, RayGrab} from "@react-three/xr";

useGLTF.preload("../demo.glb", '../draco/');

export default function DemoModel({...rest}) {
    const [hovered, setHovered] = useState(false)

    const hover = (state: boolean) => {
        setHovered(state);
    }

    useEffect(() => {
        document.body.style.cursor = hovered ? 'pointer' : 'auto'
    }, [hovered])


    // @ts-ignore
    const {nodes, materials} = useGLTF("../demo.glb", '../draco/');
    return <Suspense fallback={<Loader/>}>
        <group {...rest} dispose={null}>
            <group position={[-5, -1, 18]} rotation={[-Math.PI / 2, 0, 0]} scale={0.01}>
                <group rotation={[Math.PI / 2, 0, 0]}>
                    <group rotation={[-Math.PI / 2, 0, 0]}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes["00_Kitchen_Led_Light_Material_#66_0"].geometry}
                            material={materials.Material_66}
                        />
                    </group>
                    <group
                        position={[335.53, 0, -1747.1]}
                        rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                    >
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes["00_LV_Carpet_61332_top_00_LV_Carpet_0"].geometry}
                            material={materials["61332_top_00_LV_Carpet"]}
                        />
                    </group>
                    <group rotation={[-Math.PI / 2, 0, 0]}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes["00_1FLOOR_Concrete_Floor_Semigloss_1FLOOR_0"].geometry
                            }
                            material={materials.Concrete_Floor_Semigloss_1FLOOR}
                        />
                    </group>
                    <group rotation={[-Math.PI / 2, 0, 0]}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes["00_ALL_WALS_Wall_Paint_White_Matte_ALL_WALS_0"].geometry
                            }
                            material={materials.Wall_Paint_White_Matte_ALL_WALS}
                        />
                    </group>
                    <group rotation={[-Math.PI / 2, 0, 0]}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes[
                                    "00_BALCONY_FRAME_Aluminium_Black_Anodized0_BALCONY_FRAME_0"
                                    ].geometry
                            }
                            material={materials.Aluminium_Black_Anodized0_BALCONY_FRAME}
                        />
                    </group>
                    <group position={[0, 0, 5.44]} rotation={[-Math.PI / 2, 0, 0]}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes[
                                    "00_Balcony_Railing_Aluminium_Black_Anodized0_00_Balcony_Railin"
                                    ].geometry
                            }
                            material={materials.Aluminium_Black_Anodized0_00_Balcony_Railing}
                        />
                    </group>
                    <group rotation={[-Math.PI / 2, 0, 0]}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes["00_BALCONY_WALLS_Balcony_Walls_0"].geometry}
                            material={materials.Balcony_Walls}
                        />
                    </group>
                    <group rotation={[-Math.PI / 2, 0, 0]}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes["00_BEDROOM_WALLS_BEDROOM_WALLS_0"].geometry}
                            material={materials.BEDROOM_WALLS}
                        />
                    </group>
                    <group rotation={[-Math.PI / 2, 0, 0]}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes["00_CORRIDOR_WALLS_Corridor_walls_0"].geometry}
                            material={materials.Corridor_walls}
                        />
                    </group>
                    <group rotation={[-Math.PI / 2, 0, 0]}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes["00_CUT_2_Grey_Cut_00_CUT_0"].geometry}
                            material={materials.Grey_Cut_00_CUT}
                        />
                    </group>
                    <group rotation={[-Math.PI / 2, 0, 0]}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes["00_Fence_1_BFENCE_0"].geometry}
                            material={materials.BFENCE}
                        />
                    </group>
                    <group rotation={[-Math.PI / 2, 0, 0]}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes["00_Fence_2_Aluminium_Black_Anodized0_00_Fence_2_0"]
                                    .geometry
                            }
                            material={materials.Aluminium_Black_Anodized0_00_Fence_2}
                        />
                    </group>
                    <group rotation={[-Math.PI / 2, 0, 0]}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes[
                                    "00_French_Door_1_Aluminium_Black_Anodized0_01_French_Door_1_0"
                                    ].geometry
                            }
                            material={materials.Aluminium_Black_Anodized0_01_French_Door_1}
                        />
                    </group>
                    <group rotation={[-Math.PI / 2, 0, 0]}>
                        <Interactive onHover={() => hover(true)} onBlur={() => hover(false)}>
                            <mesh
                                castShadow
                                receiveShadow
                                geometry={
                                    nodes[
                                        "00_Kitchen_Tiles_Porcelain_White_Edges_Glossy1_01_Kitchen_Tile"
                                        ].geometry
                                }
                                material={
                                    materials.Porcelain_White_Edges_Glossy1_01_Kitchen_Tiles
                                }
                            />
                        </Interactive>
                    </group>
                    <group rotation={[-Math.PI / 2, 0, 0]}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes["00_RIGHT_WALL_1FLOOR_RIGHWALL_UP_0"].geometry}
                            material={materials.RIGHWALL_UP}
                        />
                    </group>
                    <group rotation={[-Math.PI / 2, 0, 0]}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes["00_RIGTH_WALL_GF_RIGHT_WALL_GF_0"].geometry}
                            material={materials.RIGHT_WALL_GF}
                        />
                    </group>
                    <group
                        position={[532.45, 570, -1300.75]}
                        rotation={[-Math.PI / 2, 0, 0]}
                    >
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes["00_SMALL_WALL_Wall_Paint_White_Matte_SMALL_WALL_0"]
                                    .geometry
                            }
                            material={materials.Wall_Paint_White_Matte_SMALL_WALL}
                        />
                    </group>
                    <group rotation={[-Math.PI / 2, 0, 0]}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes[
                                    "00_Stair_Railing_Aluminium_Black_Anodized0_00_Stair_Railing_0"
                                    ].geometry
                            }
                            material={materials.Aluminium_Black_Anodized0_00_Stair_Railing}
                        />
                    </group>
                    <group rotation={[-Math.PI / 2, 0, 0]}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes["00_STAIR_STEPS_Oak_Honey_Semigloss_00_STAIR_STEPS_0"]
                                    .geometry
                            }
                            material={materials.Oak_Honey_Semigloss_00_STAIR_STEPS}
                        />
                    </group>
                    <group rotation={[-Math.PI / 2, 0, 0]}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes["00_TOILET_WALLS_Material_#2145966919_0"].geometry
                            }
                            material={materials.Material_2145966919}
                        />
                    </group>
                    <group rotation={[-Math.PI / 2, 0, 0]}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes["00_TOP_CELLING_Wall_Paint_White_Matte_00_TOP_CELLING_0"]
                                    .geometry
                            }
                            material={materials.Wall_Paint_White_Matte_00_TOP_CELLING}
                        />
                    </group>
                    <group rotation={[-Math.PI / 2, 0, 0]}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes[
                                    "00_Window_Double_Aluminium_Black_Anodized0_01_Window_Double_0"
                                    ].geometry
                            }
                            material={materials.Aluminium_Black_Anodized0_01_Window_Double}
                        />
                    </group>
                    <group rotation={[-Math.PI / 2, 0, 0]}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes["03_BATH_Material_#569_03_BATH_0"].geometry}
                            material={materials.Material_569_03_BATH}
                        />
                    </group>
                    <group rotation={[-Math.PI / 2, 0, 0]}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes["03_SINK_Material_#581_06_SINK_0"].geometry}
                            material={materials.Material_581_06_SINK}
                        />
                    </group>
                    <group rotation={[-Math.PI / 2, 0, 0]}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes["03_TOILET_2_Material_#593_06_TOILET_2_0"].geometry
                            }
                            material={materials.Material_593_06_TOILET_2}
                        />
                    </group>
                    <group rotation={[-Math.PI / 2, 0, 0]}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes["03_TOILET_SINK_Material_#988_TOILET_SINK_0"].geometry
                            }
                            material={materials.Material_988_TOILET_SINK}
                        />
                    </group>
                    <group rotation={[-Math.PI / 2, 0, 0]}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes["03_TOILET_WC_Material_#1000_TOILET_WC_0"].geometry
                            }
                            material={materials.Material_1000_TOILET_WC}
                        />
                    </group>
                    <group
                        position={[251.63, 41.7, -1479.78]}
                        rotation={[-Math.PI / 2, 0, -Math.PI / 4]}
                    >
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes["04__Cassina_Table_Copper_Satin_Clean_00_Cassina_Table_0"]
                                    .geometry
                            }
                            material={materials.Copper_Satin_Clean_00_Cassina_Table}
                        />
                    </group>
                    <group
                        position={[574.01, 298.94, -1372.57]}
                        rotation={[-Math.PI / 2, 0, -0.87]}
                        scale={0.82}
                    >
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes["04_Bean_Bag_Chair_BBC_Bean_Bag_Chair_0"].geometry
                            }
                            material={materials.BBC_Bean_Bag_Chair}
                            onPointerOver={() => hover(true)}
                            onPointerOut={() => hover(false)}
                            onClick={(e) => {
                                e.stopPropagation();
                                window.open('https://www.bigberthaoriginal.de/products/gaming-sitzsack-sessle-cord-schiefergrau-1?variant=21254669107283', '_blank')
                            }}

                        >
                        </mesh>
                    </group>
                    <group
                        position={[492.52, 302.31, -492.36]}
                        rotation={[-Math.PI / 2, 0, Math.PI / 2]}
                    >
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes["04_BED_FRAME_Color_F16_04_BED_FRAME_0"].geometry}
                            material={materials.Color_F16_04_BED_FRAME}
                        />
                    </group>
                    <group
                        position={[476.36, 320.08, -498.22]}
                        rotation={[-Math.PI / 2, 0, Math.PI / 2]}
                    >
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes["04_BED_MATRASS_Material_#1037_BED_MATRASS_0"].geometry
                            }
                            material={materials.Material_1037_BED_MATRASS}
                            onPointerOver={() => hover(true)}
                            onPointerOut={() => hover(false)}
                            onClick={(e) => {
                                e.stopPropagation();
                                window.open('https://www.matratzen-concord.de/-komfortschaummatratze-mlily-deluxe-air-d010301024.html?varId=DE3070103&gclid=Cj0KCQjw0oyYBhDGARIsAMZEuMsVmWH6vmxX4vsLwiXDPmLazznxZms8JP5FlQZxk6Fdmd6nkK2cGYoaAtJoEALw_wcB', '_blank')
                            }}
                        />
                    </group>
                    <group
                        position={[276.77, 319.99, -588.73]}
                        rotation={[-Math.PI / 2, 0, 0]}
                    >
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes["04_BEDFRAME_2_Pine_Highgloss_WOOD_04_BEDFRAME_2_0"]
                                    .geometry
                            }
                            material={materials.Pine_Highgloss_WOOD_04_BEDFRAME_2}
                        />
                    </group>
                    <group
                        position={[572.1, 301.48, -657.11]}
                        rotation={[-Math.PI / 2, 0, Math.PI / 2]}
                        scale={1.09}
                    >
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes["04_BEDROOM_CHAIR_Pine_Highgloss_BEDROOM_CHAIR_0"]
                                    .geometry
                            }
                            material={materials.Pine_Highgloss_BEDROOM_CHAIR}
                            onPointerOver={() => hover(true)}
                            onPointerOut={() => hover(false)}
                            onClick={(e) => {
                                e.stopPropagation();
                                window.open('https://www.xxxlutz.de/p/stuhl-kernbuche-massiv-buchefarben-001207000801?utm_term=001207000801&utm_content=IMMEDIATELY&utm_source=google-g-shoparade&utm_medium=shopping&gclid=Cj0KCQjw0oyYBhDGARIsAMZEuMvT2pZfK9wipyC7shKWWmGv_Yk_sODKl5qr_UGknUL0YI9JWwqnPsgaAorUEALw_wcB', '_blank')
                            }}
                        />
                    </group>
                    <group position={[0, 0, 0.39]} rotation={[-Math.PI / 2, 0, 0]}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes["04_BEDROOM_KAST_PVC_White_Glossy_BEDROOM_KAST_0"]
                                    .geometry
                            }
                            material={materials.PVC_White_Glossy_BEDROOM_KAST}
                        />
                    </group>
                    <group
                        position={[602.74, 377.69, -654.7]}
                        rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                    >
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes["04_BEDROOM_TABLE_MultiMat_0_BEDROOM_TABLE_0"].geometry
                            }
                            material={materials.MultiMat_0_BEDROOM_TABLE}
                        />
                    </group>
                    <group
                        position={[624.56, 188.71, -1544.64]}
                        rotation={[Math.PI, -1.57, 0]}
                    >
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes["04_BOLIA_SHELVES_Material_#911_BOLIA_SHELVES_0"].geometry
                            }
                            material={materials.Material_911_BOLIA_SHELVES}
                        />
                    </group>
                    <group
                        position={[357.44, 359.52, -1548.07]}
                        rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                        scale={[0.41, 0.42, 0.42]}
                    >
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes["04_BURO_Material_#786_BURO_0"].geometry}
                            material={materials.Material_786_BURO}
                        />
                    </group>
                    <group
                        position={[500.63, 34.16, -1718.45]}
                        rotation={[Math.PI, -1.51, 1.57]}
                        scale={17.97}
                    >
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes["04_COFFEE_TABLE_PVC_White_Glossy0_COFFEE_TABLE_0"]
                                    .geometry
                            }
                            material={materials.PVC_White_Glossy0_COFFEE_TABLE}
                        />
                    </group>
                    <group
                        position={[268.24, 18.66, -1782.16]}
                        rotation={[-Math.PI / 2, 0, -1.57]}
                    >
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes["04_Couch_Material_#271_00_Couch_0"].geometry}
                            material={materials.Material_271_00_Couch}
                        />
                    </group>
                    <group
                        position={[309.82, 300.63, -1362.1]}
                        rotation={[-Math.PI / 2, 0, Math.PI / 2]}
                    >
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes["04_EAMES_CHAIR_Material_#886_EAMES_CHAIR_0"].geometry
                            }
                            material={materials.Material_886_EAMES_CHAIR}
                        />
                    </group>
                    <group
                        position={[624.22, 300.29, -317.81]}
                        rotation={[-Math.PI / 2, 0, 2.88]}
                    >
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes["04_EAMES_SWING_CHAIR_Material_#938_EAMES_SWING_CHAIR_0"]
                                    .geometry
                            }
                            material={materials.Material_938_EAMES_SWING_CHAIR}
                        />
                    </group>
                    <group
                        position={[354.28, 119.32, -1798.48]}
                        rotation={[-1.77, -0.17, -2.46]}
                        scale={1.17}
                    >
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes["04_Floor_Lamp_Porcelain_Black_Glossy_00_Floor_Lamp_0"]
                                    .geometry
                            }
                            material={materials.Porcelain_Black_Glossy_00_Floor_Lamp}
                        />
                    </group>
                    <group
                        position={[593.28, -2.07, -1049.02]}
                        rotation={[-1.9, 0.05, 2.13]}
                    >
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes["04_HANGER_baked_Pine_Highgloss_0"].geometry}
                            material={materials.baked_Pine_Highgloss}
                        />
                    </group>
                    <RayGrab>
                        <group rotation={[-Math.PI / 2, 0, 0]}>
                            <mesh
                                castShadow
                                receiveShadow
                                geometry={
                                    nodes["04_KITCHEN_BOTTOM_PVC_White_Glossy1_04_KITCHEN_BOTTOM_0"]
                                        .geometry
                                }
                                material={materials.PVC_White_Glossy1_04_KITCHEN_BOTTOM}
                                onPointerOver={() => hover(true)}
                                onPointerOut={() => hover(false)}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    window.open('https://www.hansgrohe.de/kueche/neuheiten/s41', '_blank');
                                }
                                }
                            />
                        </group>
                    </RayGrab>
                    <group
                        position={[352.63, 0, -1298.85]}
                        rotation={[-Math.PI / 2, 0, -3.13]}
                    >
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes["04_KITCHEN_CHAIR_1_Pine_Highgloss_KITCHEN_CHAIR_1_0"]
                                    .geometry
                            }
                            material={materials.Pine_Highgloss_KITCHEN_CHAIR_1}
                        />
                    </group>
                    <group
                        position={[339.1, 0, -1446.68]}
                        rotation={[-Math.PI / 2, 0, 0]}
                    >
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes["04_KITCHEN_CHAIR_2_Pine_Highgloss_KITCHEN_CHAIR_2_0"]
                                    .geometry
                            }
                            material={materials.Pine_Highgloss_KITCHEN_CHAIR_2}
                        />
                    </group>
                    <group
                        position={[409.65, 0, -1446.68]}
                        rotation={[-Math.PI / 2, 0, 0]}
                    >
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes["04_KITCHEN_CHAIR_3_Pine_Highgloss_KITCHEN_CHAIR_3_0"]
                                    .geometry
                            }
                            material={materials.Pine_Highgloss_KITCHEN_CHAIR_3}
                        />
                    </group>
                    <group
                        position={[411.44, 0, -1298.85]}
                        rotation={[-Math.PI / 2, 0, -3.04]}
                    >
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes["04_KITCHEN_CHAIR_4_Pine_Highgloss_KITCHEN_CHAIR_4_0"]
                                    .geometry
                            }
                            material={materials.Pine_Highgloss_KITCHEN_CHAIR_4}
                        />
                    </group>
                    <group rotation={[-Math.PI / 2, 0, 0]}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes["04_KITCHEN_SINK_PVC_White_Glossy_KITCHEN_SINK_0"]
                                    .geometry
                            }
                            material={materials.PVC_White_Glossy_KITCHEN_SINK}
                        />
                    </group>
                    <group rotation={[-Math.PI / 2, 0, 0]}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes["04_Kitchen_Table_Material_#556_00_Kitchen_Table_0"]
                                    .geometry
                            }
                            material={materials.Material_556_00_Kitchen_Table}
                        />
                    </group>
                    <group rotation={[-Math.PI / 2, 0, 0]}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes["04_KITCHEN_TOP_PVC_White_Glossy2_04_KITCHEN_TOP_0"]
                                    .geometry
                            }
                            material={materials.PVC_White_Glossy2_04_KITCHEN_TOP}
                        />
                    </group>
                    <group
                        position={[353.5, 300.47, -1339.24]}
                        rotation={[-Math.PI / 2, 0, 0]}
                    >
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes[
                                    "04_Office_shelves_1_Aluminium_Black_Anodized_Office_shelves_1"
                                    ].geometry
                            }
                            material={materials.Aluminium_Black_Anodized_Office_shelves_1}
                        />
                    </group>
                    <group
                        position={[260.88, 300.47, -1339.24]}
                        rotation={[-Math.PI / 2, 0, 0]}
                    >
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes[
                                    "04_Office_shelves_2_Aluminium_Black_Anodized_Office_shelves_2"
                                    ].geometry
                            }
                            material={materials.Aluminium_Black_Anodized_Office_shelves_2}
                        />
                    </group>
                    <group
                        position={[281.37, 419.15, -589.26]}
                        rotation={[-Math.PI / 2, 0, Math.PI / 2]}
                        scale={1.39}
                    >
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes[
                                    "04_SHELVE_BEDROOM_Aluminium_Black_Anodized0_04_SHELVE_BEDROOM"
                                    ].geometry
                            }
                            material={materials.Aluminium_Black_Anodized0_04_SHELVE_BEDROOM}
                        />
                    </group>
                    <group rotation={[-Math.PI / 2, 0, 0]}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes["04_STOVE_Material_#1025_STOVE_0"].geometry}
                            material={materials.Material_1025_STOVE}
                        />
                    </group>
                    <group
                        position={[886.66, 300.95, -2149.43]}
                        rotation={[-Math.PI / 2, 0, -Math.PI]}
                    >
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes["04_Warderobe_PVC_White_Glossy_03_Warderobe_0"].geometry
                            }
                            material={materials.PVC_White_Glossy_03_Warderobe}
                        />
                    </group>
                    <group rotation={[-Math.PI / 2, 0, 0]}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes["05_DOOR_BATHROOM_Material_#731_DOOR_BATHROOM_0"].geometry
                            }
                            material={materials.Material_731_DOOR_BATHROOM}
                        />
                    </group>
                    <group rotation={[-Math.PI / 2, 0, 0]}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes["05_DOOR_BEDRROM_Material_#620_02_DOOR_BEDRROM_0"]
                                    .geometry
                            }
                            material={materials.Material_620_02_DOOR_BEDRROM}
                        />
                    </group>
                    <group rotation={[-Math.PI / 2, 0, 0]}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes["05_DOOR_TOILET_PVC_White_Glossy1_05_DOOR_TOILET_0"]
                                    .geometry
                            }
                            material={materials.PVC_White_Glossy1_05_DOOR_TOILET}
                        />
                    </group>
                    <group rotation={[-Math.PI / 2, 0, 0]}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes["05_DOOR_WARDEROBE_Material_#675_DOOR_WARDEROBE_0"]
                                    .geometry
                            }
                            material={materials.Material_675_DOOR_WARDEROBE}
                        />
                    </group>
                    <group rotation={[-Math.PI / 2, 0, 0]}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes["05_Entrance_Door_Material_#473_02_Entrance_Door_0"]
                                    .geometry
                            }
                            material={materials.Material_473_02_Entrance_Door}
                        />
                    </group>
                    <group rotation={[-Math.PI / 2, 0, 0]}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes[
                                    "05_SLIDING_DOORS_1_PVC_White_Glossy1_05_SLIDING_DOORS_1_0"
                                    ].geometry
                            }
                            material={materials.PVC_White_Glossy1_05_SLIDING_DOORS_1}
                        />
                    </group>
                    <group
                        position={[589.9, 81.53, -1492.55]}
                        rotation={[-Math.PI / 2, 0, Math.PI / 2]}
                    >
                        <group position={[-0.89, 1.25, -61.22]}>
                            <mesh
                                castShadow
                                receiveShadow
                                geometry={
                                    nodes["07_TREE2_PLANT_AM173_019_003_07_TREE2_PLANT_0"]
                                        .geometry
                                }
                                material={materials.AM173_019_003_07_TREE2_PLANT}
                            />
                        </group>
                    </group>
                    <group
                        position={[592.04, 11.36, -1491.71]}
                        rotation={[-Math.PI / 2, 0, Math.PI / 2]}
                        scale={0.93}
                    >
                        <group position={[0, 0, -11.32]}>
                            <mesh
                                castShadow
                                receiveShadow
                                geometry={
                                    nodes["07_TREE2_POT_Material_#1608_07_TREE2_POT_0"].geometry
                                }
                                material={materials.Material_1608_07_TREE2_POT}
                            />
                        </group>
                    </group>
                    <group
                        position={[341.4, 450.55, -316.55]}
                        rotation={[-Math.PI / 2, 0, -Math.PI / 4]}
                    >
                        <group position={[12.28, -13.11, -59.62]}>
                            <mesh
                                castShadow
                                receiveShadow
                                geometry={
                                    nodes["07_TREE3_LEAVES_AM173_025_002_07_TREE3_LEAVES_0"]
                                        .geometry
                                }
                                material={materials.AM173_025_002_07_TREE3_LEAVES}
                            />
                        </group>
                    </group>
                    <group
                        position={[342.06, 319.97, -299.68]}
                        rotation={[-Math.PI / 2, 0, 1.48]}
                        scale={0.87}
                    >
                        <group position={[0, 0, 18.16]}>
                            <mesh
                                castShadow
                                receiveShadow
                                geometry={
                                    nodes["07_TREE3_POT_Material_#1642_07_TREE3_POT_0"].geometry
                                }
                                material={materials.Material_1642_07_TREE3_POT}
                            />
                        </group>
                    </group>
                    <group
                        position={[340.53, 353.88, -297.41]}
                        rotation={[Math.PI, -Math.PI / 4, Math.PI]}
                        scale={0.76}
                    >
                        <group position={[5.36, 12.87, 0.26]}>
                            <mesh
                                castShadow
                                receiveShadow
                                geometry={
                                    nodes["07_TREE3_TRUNK_AM173_025_002_07_TREE3_TRUNK_0"]
                                        .geometry
                                }
                                material={materials.AM173_025_002_07_TREE3_TRUNK}
                            />
                        </group>
                    </group>
                    <group
                        position={[312.07, 420.58, -1326.11]}
                        rotation={[1.57, -Math.PI / 3, -0.09]}
                        scale={1.31}
                    >
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes["09_books_set_1_Material_#1992_09_books_set_1_0"].geometry
                            }
                            material={materials.Material_1992_09_books_set_1}
                        />
                    </group>
                    <group
                        position={[403.21, 379.64, -1327.25]}
                        rotation={[Math.PI / 2, 0, 0.1]}
                        scale={1.26}
                    >
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes["09_books_set_2_Material_#1992_09_books_set_2_0"].geometry
                            }
                            material={materials.Material_1992_09_books_set_2}
                        />
                    </group>
                    <group
                        position={[283.9, 322.47, -442.2]}
                        rotation={[-Math.PI / 2, 0, -0.66]}
                        scale={1.54}
                    >
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes["09_books_set_3_Material_#1992_09_books_set_3_0"].geometry
                            }
                            material={materials.Material_1992_09_books_set_3}
                        />
                    </group>
                    <group
                        position={[608.78, 25.27, -1719.32]}
                        rotation={[-Math.PI / 2, 0, Math.PI]}
                        scale={1.31}
                    >
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes["09_books_set_4_Material_#1992_09_books_set_4_0"].geometry
                            }
                            material={materials.Material_1992_09_books_set_4}
                        />
                    </group>
                    <group
                        position={[364, 393.61, -419.6]}
                        rotation={[-Math.PI / 2, -0.08, 0]}
                        scale={[0.71, 0.71, 0.7]}
                    >
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes.BEDROOM_LIGHT_B_0.geometry}
                            material={materials.material}
                        />
                    </group>
                    <group
                        position={[364, 393.61, -723.82]}
                        rotation={[-Math.PI / 2, -0.08, 0]}
                        scale={[0.71, 0.71, 0.7]}
                    >
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes["BEDROOM_LIGHT001_Material_#2145966892_0"].geometry
                            }
                            material={materials.Material_2145966892}
                        />
                    </group>
                    <group
                        position={[606.47, 299.76, -403.05]}
                        rotation={[-Math.PI / 2, 0, Math.PI / 2]}
                    >
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes.CARPET_BERDROOM_multi_Group_001_CARPET_BERDROOM_0.geometry
                            }
                            material={materials.multi_Group_001_CARPET_BERDROOM}
                        />
                    </group>
                    <group
                        position={[301.66, 299.69, -1399.29]}
                        rotation={[-Math.PI / 2, 0, 0]}
                    >
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes.CARPET_OFFICE_multi_Group_001_CARPET_OFFICE_0.geometry
                            }
                            material={materials.multi_Group_001_CARPET_OFFICE}
                        />
                    </group>
                    <group
                        position={[516.88, 317.98, -1742.92]}
                        rotation={[-Math.PI / 2, 0, -1.76]}
                        scale={0.8}
                    >
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes.CHANDELIER_Chandelier_0.geometry}
                            material={materials.Chandelier}
                        />
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes.CHANDELIER_Chandelier_0001.geometry}
                            material={materials.Chandelier}
                        />
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes.CHANDELIER_Chandelier_0002.geometry}
                            material={materials.Chandelier}
                        />
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes.CHANDELIER_Chandelier_0003.geometry}
                            material={materials.Chandelier}
                        />
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes.CHANDELIER_Chandelier_0004.geometry}
                            material={materials.Chandelier}
                        />
                    </group>
                    <group
                        position={[485.56, 569.89, -1269.18]}
                        rotation={[-Math.PI / 2, 0, 0]}
                    >
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes["CORRIDOR_SPOTLIGHT_Material_#1520_CORRIDOR_SPOTLIGHT_0"]
                                    .geometry
                            }
                            material={materials.Material_1520_CORRIDOR_SPOTLIGHT}
                        />
                    </group>
                    <group
                        position={[532.45, 570, -1300.75]}
                        rotation={[-Math.PI / 2, 0, 0]}
                    >
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes.CUT_Grey_Cut_00_CUT_0.geometry}
                            material={materials.Grey_Cut_00_CUT}
                        />
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes.CUT_Grey_Cut_0.geometry}
                            material={materials.Grey_Cut}
                        />
                    </group>
                    <group rotation={[-Math.PI / 2, 0, 0]}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes.FACADE_1_Concrete_Simple0_FACADE_1_0.geometry}
                            material={materials.Concrete_Simple0_FACADE_1}
                        />
                    </group>
                    <group rotation={[-Math.PI / 2, 0, 0]}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes.FACADE_2_Concrete_Simple0_FACADE_2_0.geometry}
                            material={materials.Concrete_Simple0_FACADE_2}
                        />
                    </group>
                    <group
                        position={[305.51, 83.49, -1355.36]}
                        rotation={[-Math.PI / 2, 0, 0]}
                        scale={0.01}
                    >
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes["FRUITS_Material_#1211_FRUITS_0"].geometry}
                            material={materials.Material_1211_FRUITS}
                            position={[0, 0.01, 0]}
                        />
                    </group>
                    <group
                        position={[67.21, -12.63, 10.11]}
                        rotation={[-Math.PI / 2, 0, 0]}
                        scale={1.02}
                    >
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes.GLASS_Glass_0.geometry}
                            material={materials.Glass}
                        />
                    </group>
                    <group
                        position={[384.01, 376.98, -1474.05]}
                        rotation={[-Math.PI / 2, 0, -2.09]}
                        scale={[0.11, 0.09, 0.09]}
                    >
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes["IMAC_Material_#1257_IMAC_0"].geometry}
                            material={materials.Material_1257_IMAC}
                        />
                    </group>
                    <group position={[419.28, 187.52, -1369.45]} scale={0.37}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes["KITCHEN_LIGHT_Material_#1662_KITCHEN_LIGHT_0"].geometry
                            }
                            material={materials.Material_1662_KITCHEN_LIGHT}
                        />
                    </group>
                    <group
                        position={[492.83, 269.28, -1024.25]}
                        rotation={[-Math.PI / 2, 0, 0]}
                    >
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes["KITCHEN_SPOTLIGHT_Material_#1409_0"].geometry}
                            material={materials.Material_1409}
                        />
                    </group>
                    <group
                        position={[260.46, 321.17, -1476.05]}
                        rotation={[-Math.PI / 2, 0, 0]}
                        scale={1.69}
                    >
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes["PAINTING_1_Material_#474_PAINTING_1_0"].geometry}
                            material={materials.Material_474_PAINTING_1}
                        />
                    </group>
                    <group
                        position={[260.46, 114.59, -1366.39]}
                        rotation={[-Math.PI / 2, 0, 0]}
                        scale={0.93}
                    >
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes["PAINTING_2_Material_#259_PAINTING_2_0"].geometry}
                            material={materials.Material_259_PAINTING_2}
                        />
                    </group>
                    <group
                        position={[450.19, 411.75, -1090.84]}
                        rotation={[-Math.PI / 2, 0, 0]}
                        scale={0.93}
                    >
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes["PAINTING_3_Material_#1560_PAINTING_3_0"].geometry
                            }
                            material={materials.Material_1560_PAINTING_3}
                        />
                    </group>
                    <group rotation={[-Math.PI / 2, 0, 0]}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes.SHOWER_BASE_Porcelain_White_Edges_Glossy0_SHOWER_BASE_0
                                    .geometry
                            }
                            material={materials.Porcelain_White_Edges_Glossy0_SHOWER_BASE}
                        />
                    </group>
                    <group rotation={[-Math.PI / 2, 0, 0]}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes.SHOWER_PANELS_Porcelain_Olive_Green_Glossy_SHOWER_PANELS_0
                                    .geometry
                            }
                            material={materials.Porcelain_Olive_Green_Glossy_SHOWER_PANELS}
                        />
                    </group>
                    <group rotation={[-Math.PI / 2, 0, 0]}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes.SLIDING_DOOR_Aluminium_Black_Anodized0_SLIDING_DOOR_0
                                    .geometry
                            }
                            material={materials.Aluminium_Black_Anodized0_SLIDING_DOOR}
                        />
                    </group>
                    <group
                        position={[525.79, 569.89, -471.45]}
                        rotation={[-Math.PI / 2, 0, -Math.PI]}
                    >
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes["Spotlight_003_Material_#1520_Spotlight_003_0"].geometry
                            }
                            material={materials.Material_1520_Spotlight_003}
                        />
                    </group>
                    <group
                        position={[485.56, 569.89, -1208.94]}
                        rotation={[-Math.PI / 2, 0, 0]}
                    >
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes["Spotlight_2_Material_#1520_Spotlight_2_0"].geometry
                            }
                            material={materials.Material_1520_Spotlight_2}
                        />
                    </group>
                    <group
                        position={[559.34, 379.09, -1543.28]}
                        rotation={[-2.65, 0.08, -1.61]}
                        scale={0.26}
                    >
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes["TELESCOPE_Material_#1186_TELESCOPE_0"].geometry}
                            material={materials.Material_1186_TELESCOPE}
                        />
                    </group>
                    <group
                        position={[316.48, 396.79, -1594.69]}
                        rotation={[-Math.PI / 2, 0, 0]}
                    >
                        <group position={[-3.95, -32.68, 54.97]} scale={0.81}>
                            <group position={[2.64, 50.69, -52.56]}>
                                <mesh
                                    castShadow
                                    receiveShadow
                                    geometry={
                                        nodes["07_TREE1_LEAVES_AM173_024_002_07_TREE1_LEAVES_0"]
                                            .geometry
                                    }
                                    material={materials.AM173_024_002_07_TREE1_LEAVES}
                                />
                            </group>
                        </group>
                        <group
                            position={[2.49, -1.97, -4.92]}
                            rotation={[0, 0, -1.13]}
                            scale={0.81}
                        >
                            <group position={[-5.55, 8.03, -88.79]}>
                                <mesh
                                    castShadow
                                    receiveShadow
                                    geometry={
                                        nodes["07_TREE1_TRUNK_Material_#1572_07_TREE1_TRUNK_0"]
                                            .geometry
                                    }
                                    material={materials.Material_1572_07_TREE1_TRUNK}
                                />
                            </group>
                        </group>
                    </group>
                    <group
                        position={[316.48, 396.79, -1594.69]}
                        rotation={[-Math.PI / 2, 0, 0]}
                    >
                        <group position={[8.61, 4.65, -70.59]} rotation={[0, 0, -1.3]}>
                            <group position={[0, 0, 29.37]}>
                                <mesh
                                    castShadow
                                    receiveShadow
                                    geometry={
                                        nodes["07_TREE1_POT_Material_#1654_07_TREE1_POT_0"].geometry
                                    }
                                    material={materials.Material_1654_07_TREE1_POT}
                                />
                            </group>
                        </group>
                    </group>
                    <group rotation={[-Math.PI / 2, 0, 0]}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes.WALL_OPEN_Wall_Paint_White_Matte_WALL_OPEN_0.geometry
                            }
                            material={materials.Wall_Paint_White_Matte_WALL_OPEN}
                        />
                    </group>
                    <group rotation={[-Math.PI / 2, 0, 0]}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes.WOODEN_FLOOR_0_Oak_Honey_Floor_WOODEN_FLOOR_0_0.geometry
                            }
                            material={materials.Oak_Honey_Floor_WOODEN_FLOOR_0}
                        />
                    </group>
                    <group rotation={[-Math.PI / 2, 0, 0]}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={
                                nodes.WOODEN_FLOOR_1_Oak_Honey_Floor_WOODEN_FLOOR_0.geometry
                            }
                            material={materials.Oak_Honey_Floor_WOODEN_FLOOR}
                            onPointerOver={() => hover(true)}
                            onPointerOut={() => hover(false)}
                            onClick={(e) => {
                                e.stopPropagation();
                                window.open('https://www.directwoodflooring.co.uk/rubber-wood-traditional-oak.html', '_blank')
                            }}
                        />
                    </group>
                </group>
            </group>
        </group>
    </Suspense>
}

function Loader() {
    const {progress} = useProgress();
    return <Html center>{progress} % loaded</Html>
}
